import type { Object3D } from "three"

export default function setListVisible (
  list: Array<Object3D>,
  newVisibleValue: boolean,
) {
  for (let i = 0; i < list.length; i++) {
    list[i].visible = newVisibleValue
  }
}